import React from 'react';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import Select from '../../../components/form-elements/Select';
import { areaShopSubLocationsSelector } from '../../../../modules/selectors/standort/markenStandort';
import Image from '../../../components/Image/Image';
import { subLocationToCarBrands } from '../../../../modules/selectors/standort/subLocation';

const validationSchema = Yup.object().shape({
    selectedSublocation: Yup.string().required('Pflichtfeld'),
});

function InactiveChildren({ values }) {
    const areaShopSubLocations = useSelector(areaShopSubLocationsSelector);
    const subLocation = areaShopSubLocations.find(subLocation => subLocation._id === values.selectedSublocation);

    return (
        <>
            {subLocation && (
                <div className="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid="">
                    <div>
                        <div className="uk-grid uk-grid-small" data-uk-grid="">
                            <div className="uk-width-auto uk-flex uk-flex-right">
                                <Image
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/images/brand-icons/${subLocation.hauptFabrikat}.jpeg`}
                                    alt="Logo"
                                    resizeHeight={20}
                                />
                            </div>
                            <div className="uk-width-expand uk-flex uk-flex-middle">
                                <h5>{subLocation.anschrift.firma}</h5>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="uk-grid uk-grid-small" data-uk-grid="">
                            <div className="uk-width-auto uk-flex uk-flex-right">
                                <i data-uk-icon="location" />
                            </div>
                            <div className="uk-width-expand">
                                <div>{subLocation.anschrift.strasse}</div>
                                <div>
                                    {subLocation.anschrift.plz} {subLocation.anschrift.ort}
                                </div>
                                <div>
                                    <b>{subLocation.hauptFabrikat}</b> Markenwerkstatt
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

function ActiveChildren({ values, setFieldValue, handleBlur, touched, errors }) {
    const areaShopSubLocations = useSelector(areaShopSubLocationsSelector);
    const filteredSubLocations = areaShopSubLocations.filter(subLocation => subLocation.serviceInquiry !== false);

    return (
        <Select
            name="selectedSublocation"
            id="selectedSublocation"
            label="Standort Auswahl"
            value={values.selectedSublocation}
            onChange={({ name, value }) => setFieldValue(name, value)}
            onBlur={handleBlur}
            options={[
                { label: 'Bitte wählen Sie einen Standort aus', value: '' },
                ...filteredSubLocations.map(subLocation => ({
                    label: `${subLocation.anschrift.strasse} • ${subLocation.anschrift.plz} ${
                        subLocation.anschrift.ort
                    } • ${subLocationToCarBrands(subLocation).join(', ')}`,
                    value: subLocation._id,
                })),
            ]}
            error={touched.selectedSublocation && errors.selectedSublocation}
        />
    );
}

export const locationSelectorStepFactory = () => {
    return {
        inactiveChildren: props => <InactiveChildren {...props} />,
        activeChildren: props => <ActiveChildren {...props} />,
        title: 'Standortauswahl',
        initialValues: { selectedSublocation: '' },
        validationSchema,
    };
};
